import dayjs from 'dayjs';
import dayjsMixin from '../../../../mixins/dayjs';

export default {
  name: 'CalendarDateNav',
  mixins: [dayjsMixin],
  model: {
    prop: 'value',
    event: 'change',
  },
  events: ['change', 'change-month', 'change-year', 'open-month', 'open-year'],
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      date: null,
      isSameDate: false,
      transitionEnterClass: '',
      transitionLeaveClass: '',
    };
  },
  computed: {
    monthFormatted() {
      return this.date.locale(this.locale).format('MMMM');
    },
    yearFormatted() {
      return this.date.locale(this.locale).format('YYYY');
    },
  },
  watch: {
    value: {
      handler(value) {
        const date = dayjs(value);
        this.date = date.isValid() ? date : dayjs();
      },
      immediate: true,
    },
    date(value, oldValue) {
      this.isSameDate =
        value.isSame(oldValue, 'month') &&
        value.isSame(oldValue, 'year');
      this.emitEvent('change', value);

      if (value.isAfter(oldValue, 'month')) this.updateTransitionClass('next');
      if (value.isBefore(oldValue, 'month')) this.updateTransitionClass('prev');
      if (value.isAfter(oldValue, 'year')) this.updateTransitionClass('next');
      if (value.isBefore(oldValue, 'year')) this.updateTransitionClass('prev');
    },
  },
  methods: {
    openMonthView() {
      this.$emit('open-month');
    },
    openYearView() {
      this.$emit('open-year');
    },
    nextMonth() {
      this.date = this.date.add(1, 'month');
      this.emitEvent('change-month', this.date);
    },
    prevMonth() {
      this.date = this.date.subtract(1, 'month');
      this.emitEvent('change-month', this.date);
    },
    nextYear() {
      this.date = this.date.add(1, 'year');
      this.emitEvent('change-year', this.date);
    },
    prevYear() {
      this.date = this.date.subtract(1, 'year');
      this.emitEvent('change-year', this.date);
    },
    emitEvent(name, value, checkDate = true, props = this.value) {
      if (typeof props === 'string') {
        this.$emit(name, value.toISOString());
      } else {
        if (checkDate) {
          if (!this.isSameDate) this.$emit(name, value);
        } else {
          this.$emit(name, value);
        }
      }
    },
    updateTransitionClass(direction) {
      if (direction === 'prev') {
        this.transitionEnterClass = 'animated fadeSlideInLeft';
        this.transitionLeaveClass = 'animated fadeSlideOutRight';
      }
      if (direction === 'next') {
        this.transitionEnterClass = 'animated fadeSlideInRight';
        this.transitionLeaveClass = 'animated fadeSlideOutLeft';
      }
    },
  },
};
